export default class Document {
    constructor(
        title,
        document_context,
        document_purpose,
        document_type_id,
        business_unit_id,
        industry_id,
        business_domain_ids ,
        files = [],
        offering_ids ,
        track_id,
        authors_ids ,
        tags = [],
    ) {
        this.title = title;
        this.document_context = document_context;
        this.document_purpose = document_purpose;
        this.document_type_id = document_type_id;
        this.business_unit_id = business_unit_id;
        this.industry_id = industry_id;
        this.business_domain_ids = business_domain_ids;
        this.files = files;
        this.offering_ids = offering_ids;
        this.track_id = track_id;
        this.authors_ids = authors_ids;
        this.tags = tags;
    }
}
